/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EcoLeadBody from "components/CRMComponents/CRMEcoLead/EcoLeadBody";

const EcoLeadList = () => {
  useEffect(() => {
    document.title = "CRM Eco leads";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <EcoLeadBody />
    </main>
  );
};

export default EcoLeadList;
